/**
 * v0.3
 * @author Gabe Rose (gabe@equisolve.com)
 * This plugin is used to generate and configure charts dynamically via an HTML data
 * attribute interface.
 **/
function ChartBuilder (el) {
    var apiUrl = '/api/v1/chart-data';
    var self = this;
    this.el = el;
    this.cid = el.getAttribute('data-cid');
    this.pid = el.getAttribute('data-pid');
    this.name = el.getAttribute('data-chart-name');
    this.type = el.getAttribute('data-chart-type');
    this.fieldName = el.getAttribute('data-field-name');
    this.unitType = el.getAttribute('data-unit-type');
    this.donutSolid = el.getAttribute('data-donut-solid') == 'true' ? true : false;
    this.isFinancialChart = el.getAttribute('data-financial-chart');
    this.legend = el.getAttribute('data-legend') === 'true' ? true : false;
    this.extraOptionsId = el.getAttribute('data-extra-options-id');
    this.unitScale = el.getAttribute('data-unit-scale');
    this.width = el.getAttribute('data-width');
    this.data = {};
    this.chart = {};
    this.events = {
        afterDraw: new Event('afterDraw')
    };
    
    function getOptions() {
        var opts = {};
        if (self.type == 'pie') {
            opts = {
                height: 270,
                donut: true,
                donutWidth: 50,
                donutSolid: self.donutSolid,
                showLabel: false,
                plugins: [
                    // Chartist.plugins.ctPieLabels({
                    //     labelInterpolationFnc: function (value, totalValueSum) {
                    //         return Math.round((value / totalValueSum) * 100) + '%';
                    //     }
                    // }),
                    Chartist.plugins.legend({
                        clickable: false,
                        position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                    }),
                    Chartist.plugins.tooltip({
                        appendToBody: true,
                        tooltipFnc: function (meta, value, index) {
                            return self.data.labels[index];
                        }
                    })
                ]
            };
        }else {
            opts = {
                height: 250,
                width: self.width,
                distributeSeries: true,
                axisX: {
                    showGrid: false,
                },
                axisY: {
                    showGrid: false,
                    showLabel: false,
                    offset: 0
                },
                seriesBarDistance: 15,
                plugins: [
                    Chartist.plugins.ctBarLabels({
                        labelInterpolationFnc: function (text) {
                            if (self.unitType == 'currency') {
                                if (self.unitScale == 'M') {
                                    var value = parseFloat(text) / 1000000
                                    value = value.toFixed(2);
                                }
                                return '$' + value.toLocaleString();
                            }
                            return text.toLocaleString();
                        },
                        position: {
                            y: function (data) {
                                return data.y2 - 10;
                            }
                        }
                    }),                    
                ]
            }
            if (self.legend) {
                opts.plugins.push(Chartist.plugins.legend({
                    clickable: false,
                    position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                }));
            }
        }
        return opts;
    }    
    
    function registerHandlers ()
    {
        self.chart.on('draw', function (event) {
            // X-axis label centering fix for IE11
            if (event.type === 'label' && event.axis && event.axis.units.pos === 'x') {
                if (!self.chart.supportsForeignObject) {
                    event.element.attr({
                        x: event.x + (event.width / 2) - 15,
                        'text-anchor': 'middle'
                    });
                }
            }
        });
        jq('.nav a').on('shown.bs.tab', function (e) {
            console.log('tab shown');
            var target = jq(this).attr('href');
            
            if (jq(target).find(self.el).length > 0) {
                console.log('update chart');
                self.chart.update();
            }
        });
    }
    
    function getChartData () {
        return new Promise(function (resolve, reject) {
            var url = new URL(window.location.protocol + '//' + window.location.hostname + apiUrl),
            params = {
                cid: self.cid,
                pid: self.pid,
                chart_name: self.name,
                field_name: self.fieldName,
                is_financial_chart: self.isFinancialChart
            };
            Object.keys(params).forEach(function (key) {
                url.searchParams.append(key, params[key]);
            });
            fetch(url).then(function (response) {
                return response.json();
            }).then(function (results) {
                var resultsData = results.data.map(function (el, i) {
                        return el.match(/[\d.]+/g)[0];
                    });
                    self.data.series = resultsData;
                    self.data.labels = results.labels;
                    // Holds full value strings to use in the legend
                    self.data.labelValues = results.data;
                    if (self.legend) {
                        //If there's a legend, transform the labels.
                        self.data.labels = results.labels.map(function (el, i) {
                                var prefix = '';
                                if (self.unitType == 'percentage') {
                                    suffix = '<span class="percent">' + self.data.series[i] + '%</span>';
                                } else if (self.unitType == 'currency') {
                                    suffix = '<span class="currency">$' + self.data.labelValues[i] + '</span> ';
                                    if (self.unitScale == 'M') {
                                        el = el / 1000000
                                        el = el.toFixed(2);
                                    }
                                }
                                return el + suffix;
                        });
                    }
                resolve();
            });
        });
    }
    getChartData().then(function () {
      // We allow for entirely custom options to be passed via a JSON script.
      var customOpts = {};  
      if (document.getElementById(self.extraOptionsId)) {
          customOpts = JSON.parse(document.getElementById(self.extraOptionsId).innerHTML);
      }
      var opts = Object.assign({}, getOptions(), customOpts);
      if (self.type == 'pie') {
          self.chart = new Chartist.Pie(self.el, self.data, opts);
      }else {
          self.chart = new Chartist.Bar(self.el, self.data, opts);
      }
      registerHandlers();
      self.el.dispatchEvent(self.events.afterDraw);
    });
}

var charts = document.querySelectorAll('.chartist-chart')
if (charts.length) {
    charts.forEach(function (el) {
        new ChartBuilder(el);
    });
}